import { addDays } from 'date-fns';

import { FALLBACK_SESSION_DAYS } from './meta';

export const cookieOptions = (hostname: string, expires?: Date) => {
  return {
    domain: getRootDomain(hostname),
    expires: expires ?? addDays(new Date(), FALLBACK_SESSION_DAYS),
    sameSite: 'lax' as const,
    secure: process.env.NODE_ENV !== 'development',
  };
};

const getRootDomain = (hostname: string): string | undefined => {
  if (hostname === 'aurorasolar.com') {
    return '.aurorasolar.com';
  }

  // Allow the cookies to be shared between quote.aurorasolar.com and aurorasolar.com
  if (/^(quote|www)\.(dev|qa|staging)?\.?aurorasolar\.com$/.test(hostname)) {
    return hostname.replace(/^(quote|www)/, '');
  }
};
